<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container>
    <div class="list-view-header">
        <div class="row mr-0 justify-content-md-between"
             [class.justify-content-center]="!(showQuickFilters && enableQuickFilters)"
             [class.justify-content-end]="(showQuickFilters && enableQuickFilters)">
            <div class="custom-col-4 d-none d-md-flex align-items-center">
                <scrm-module-title class="list-view-title" [title]="moduleTitle"></scrm-module-title>
            </div>
            <div class="custom-col-8 d-flex align-items-center"
                 [class.pr-3]="(showQuickFilters && enableQuickFilters)"
            >
                <scrm-settings-menu></scrm-settings-menu>
            </div>
        </div>

        <div *ngIf="showQuickFilters && enableQuickFilters"
             class="d-flex align-items-baseline w-100 justify-content-end pr-3">
            <div class="text-nowrap text-muted fs-70 pl-1 mr-1">
                <scrm-label labelKey="LBL_QUICK_FILTERS"></scrm-label>
            </div>
            <div class="pr-xxl-1 mr-xxl-1">
                <scrm-button-group *ngIf="quickFilters.config$" [config$]="quickFilters.config$" [klass]="'quick-filter-button'"></scrm-button-group>
            </div>
        </div>

        <div class="list-view-hr-container">
            <hr class="list-view-hr">
        </div>
        <div *ngIf="actionPanel === 'filters'" class="container-fluid pt-2 small-font">
            <div class="row">
                <div class="col">
                    <scrm-list-filter [config]="filterAdapter.getConfig()"></scrm-list-filter>
                </div>
            </div>
        </div>
        <div *ngIf="actionPanel === 'recordPanel' && recordPanelConfig" class="container-fluid pt-2 small-font">
            <div class="row">
                <div class="col">
                    <scrm-record-panel [config]="recordPanelConfig"></scrm-record-panel>
                </div>
            </div>
        </div>
    </div>
</ng-container>
